import React, { useState } from 'react';

import { useDispatch, useSelector } from "react-redux";
import allActions from "../../../actions";

import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import ToggleButton from '@material-ui/lab/ToggleButton';
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup';
import CircularProgress from '@material-ui/core/CircularProgress';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import { makeStyles } from '@material-ui/core/styles';
import SyncAltIcon from '@material-ui/icons/SyncAlt';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';

import UnoButton from '../../utils/UnoButton'

import { toogleButton, unoTheme } from "../../../assets/styles/unoTheme";

import { checkUserIsRole, roles } from '../../utils/user';


const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
    },
    header: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: theme.spacing(3)
    },
    main: {
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        paddingLeft: theme.spacing(5),
        paddingRight: theme.spacing(5),
        textAlign: 'left',
        overflowY: 'scroll',
        borderTop: 'solid 1px #ccc',
        padding: '24px',
        '& .MuiPaper-root': {
            height: 'calc(100% - 184px)',
        }
    },
    blue: {
        color: "blue",
        fontWeight: 'bold'
    },
    hiddenIcon: {
        visibility: 'hidden',
    },
    bottom: {
        display: 'flex',
        alignItems: 'flex-end',
        flexDirection: 'column',
        justifyContent: 'flex-end',
        '& .bottomButtons': {
            paddingTop: theme.spacing(2),
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between'
        }
    },
    rightDivBackdrop: {
        backgroundColor: 'white',
        position: 'absolute',
        opacity: 0.7,
        top: 0,
        bottom: 0,
        right: 0,
        left: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        '& .progress': {
            color: unoTheme.mainColor
        }
    },
    contentModal: {
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: 'white',
        alignItems: 'center',
        paddingBottom: theme.spacing(4),
        '& .titlesModal': {
            fontWeight: 'bold',
            marginBottom: '16px',
        },
        '& .periodSelect': {
            marginTop: '24px',
            width: '100%',
            padding: '24px 0px 0px 0px',
            borderTop: '1px solid #ced4da',
            textAlign: 'center',

            '& .selectors': {
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            },
            '& .alertNoPeriod': {
                marginTop: '26px',
                color: 'red',
                fontSize: '12px',
                width: '180px',
            },
            '& .formPersonalizaded': {
                textAlign: 'left',
                marginTop: '16px',
                padding: '16px',
                backgroundColor: '#eeeeee',
                borderRadius: '10px',
                '& .MuiTypography-root': {
                    fontSize: '13px',
                }
            }
        },
    },
    toogleButton: toogleButton,
}));

export default function SelectPeriodTypeXml(props) {
    const { content } = props
    const classes = useStyles();
    const dispatch = useDispatch();

    const currentUser = useSelector(state => state.currentUser);
    const activeClients = useSelector(state => state.activeClients);
    const [openBackdrop, setOpenBackdrop] = useState(false);
    const [mainPeriod, setMainPeriod] = useState('month');
    const [xmlType, setXmlType] = useState('transaction');
    const [selectedMonth, setSelectedMonth] = useState(parseInt(content.client?.selectedPortfolioMonth) || new Date().getMonth() + 1);
    const [selectedYear, setSelectedYear] = useState(parseInt(content.client?.selectedPortfolioYear) || new Date().getFullYear());
    const [selectedClient, setSelectedClient] = useState(content.client);

    const spClients = activeClients.filter(client => client.uf === "SP");

    const months = [
        { value: 1, label: 'Janeiro' },
        { value: 2, label: 'Fevereiro' },
        { value: 3, label: 'Março' },
        { value: 4, label: 'Abril' },
        { value: 5, label: 'Maio' },
        { value: 6, label: 'Junho' },
        { value: 7, label: 'Julho' },
        { value: 8, label: 'Agosto' },
        { value: 9, label: 'Setembro' },
        { value: 10, label: 'Outubro' },
        { value: 11, label: 'Novembro' },
        { value: 12, label: 'Dezembro' },
    ];

    const years = Array.from({ length: 10 }, (_, i) => new Date().getFullYear() - i);

    const handleMainPeriod = (_, newValue) => {
        if (newValue) setMainPeriod(newValue);
    };

    const handleXmlType = (_, newValue) => {
        if (newValue) setXmlType(newValue);
    };

    const doXml = () => {
        console.log("doXml - selectedClient:", selectedClient);
        console.log("doXml - selectedMonth:", selectedMonth, typeof selectedMonth);
        console.log("doXml - selectedYear:", selectedYear, typeof selectedYear);
        
        if (!selectedClient) {
            dispatch(allActions.notificationActions.showNotification({
                message: 'Selecione um cliente',
                type: 'warning'
            }));
            return;
        }
        const configXml= {client: selectedClient, mainPeriod, xmlType, selectedMonth, selectedYear};
        console.log("doXml - configXml:", configXml);
        dispatch(allActions.xmlLoadActions.setXmlLoad({
            show: true,
            ...configXml,
            message: 'Gerando xml...',
        }));
    };

    const openAlignModal = () => {
        if (!selectedClient) {
            dispatch(allActions.notificationActions.showNotification({
                message: 'Selecione um cliente',
                type: 'warning'
            }));
            return;
        }
        dispatch(allActions.rightContentActions.setRightContent({
            path: 'alignAudesp',
            client: selectedClient,
        }));
    };

    return (
        <div className={classes.root}>
            <div className={classes.header}>
                <IconButton
                    className={classes.hiddenIcon}>
                    <ArrowBackIcon />
                </IconButton>
                <div>
                    <Typography
                        variant={'h6'}
                        align={'left'}>
                        {"Configuração de XML"}
                    </Typography>
                </div>
                <IconButton
                    onClick={() => dispatch(allActions.rightContentActions.setRightContent(null))}>
                    <CloseIcon />
                </IconButton>
            </div>


            <div className={classes.main}>
                <div
                    className={classes.contentModal}>

                    <Typography className={'titlesModal'}>{"1. Selecione o prazo"}</Typography>

                    <ToggleButtonGroup
                        className={classes.toogleButton}
                        exclusive value={mainPeriod} onChange={handleMainPeriod} aria-label="text formatting">
                        <ToggleButton value="month" aria-label="mensal">
                            {'Mensal'}
                        </ToggleButton>
                        <ToggleButton value="quarter" aria-label="trimestral">
                            {'Trimestral'}
                        </ToggleButton>
                    </ToggleButtonGroup>

                    <div style={{ display: 'flex', gap: '16px', marginTop: '16px', justifyContent: 'center' }}>
                        <TextField
                            select
                            label="Mês"
                            value={selectedMonth}
                            onChange={(e) => setSelectedMonth(parseInt(e.target.value))}
                            style={{ width: '140px' }}
                            size="small"
                        >
                            {months.map((m) => (
                                <MenuItem key={m.value} value={m.value}>
                                    {m.label}
                                </MenuItem>
                            ))}
                        </TextField>
                        <TextField
                            select
                            label="Ano"
                            value={selectedYear}
                            onChange={(e) => setSelectedYear(parseInt(e.target.value))}
                            style={{ width: '100px' }}
                            size="small"
                        >
                            {years.map((y) => (
                                <MenuItem key={y} value={y}>
                                    {y}
                                </MenuItem>
                            ))}
                        </TextField>
                    </div>

                    <div className="periodSelect">
                        <Typography className={'titlesModal'}>{"2. Selecione o tipo"}</Typography>
                        <ToggleButtonGroup
                            className={classes.toogleButton}
                            exclusive value={xmlType} onChange={handleXmlType} aria-label="text formatting">
                            <ToggleButton value="transaction" aria-label="Movimento">
                                {'Movimento'}
                            </ToggleButton>
                            <ToggleButton value="register" aria-label="cadastro">
                                {'Cadastro'}
                            </ToggleButton>
                            <ToggleButton value="alteration" aria-label="alteração">
                                {'Alteração'}
                            </ToggleButton>
                        </ToggleButtonGroup>
                    </div>

                    <div className="periodSelect">
                        <Typography className={'titlesModal'}>{"3. Selecione o cliente (SP)"}</Typography>
                        <TextField
                            select
                            label="Cliente"
                            value={selectedClient?.id || ''}
                            onChange={(e) => {
                                const client = spClients.find(c => c.id === Number(e.target.value));
                                setSelectedClient(client);
                            }}
                            style={{ width: '100%', minWidth: '250px' }}
                            size="small"
                        >
                            {spClients.map((client) => (
                                <MenuItem key={client.id} value={client.id}>
                                    {client.label_name}
                                </MenuItem>
                            ))}
                        </TextField>
                    </div>
                </div>
                <br />
                <div className={classes.bottom}>
                    <div style={{ display: "flex", alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                        {checkUserIsRole(currentUser, [roles.superadmin]) && (
                            <UnoButton
                                onClick={() => openAlignModal()}
                                type={'secondary'}
                                startIcon={<SyncAltIcon />}>
                                {'Alinhar Códigos'}
                            </UnoButton>
                        )}
                        <UnoButton
                            onClick={() => doXml()}
                            type={'primary'}>
                            {'Gerar XML'}
                        </UnoButton>
                    </div>
                </div>
            </div>
            {
                openBackdrop ?
                    <div className={classes.rightDivBackdrop}>
                        <CircularProgress className={'progress'} />
                    </div> : null
            }
        </div >
    );
}



